export default __webpack_public_path__ + "static/media/reactjs.4f7abcc3.svg";